import request from "../../utils/request";

//获取组织架构信息
export function listOrganization(query){
  return request({
    url: "/employeeinfo/v1/organization/",
    method: 'get',
    params: query
  })
}
//获取组织架构详细信息
export function getOrganization(id){
  return request({
    url: "/employeeinfo/v1/organization/" + id + "/",
    method: 'get'
  })
}

//新增组织架构列表
export function addOrganization(data){
  return request({
    url: "/employeeinfo/v1/organization/",
    method: 'post',
    data: data
  })
}

//修改组织架构信息
export function editOrganization(data){
  return request({
    url: "/employeeinfo/v1/organization/"+ data.id + '/',
    method: 'put',
    data: data
  })
}

//删除组织架构信息
export function deleteOrganization(id){
  return request({
    url: "/employeeinfo/v1/organization/"+ id + '/' ,
    method: 'delete'
  })
}

export function getTreeOrganization(){
  return request({
    url: "/employeeinfo/v1/organizations_tree/",
    method: 'get'
  })
}

export function getUserTreeOrganization(){
  return request({
    url: "/employeeinfo/v1/organization_user_tree/",
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/employeeInfo/organization.js